<template>
  <div class="filters-box-row">
		<div class="filters-container">
			<div class="input-box">
				<span>店铺名称：</span>
				<el-input
					v-model="shopName"
					placeholder="请输入店铺名称"
					class="filter-input"
					size="small"
					@keyup.enter.native="search"
				></el-input>
			</div>
			<el-button size="small" type="primary" class="btn" @click="search">查询</el-button>
			<el-button size="small" plain class="btn" @click="clear">清空</el-button>
		</div>
  </div>
</template>

<script>
export default {
	name: 'search',
	data () {
		return {
			shopName: ''
		}
	},
	methods: {
		search () {
			this.$emit('search', this.shopName)
		},
		clear () {
			this.shopName = ''
			this.search()
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	border-bottom :1px solid #DCE2FD
	display: flex;
	flex-direction column
	padding: 10px 0;
	width :100%;
	line-height :60px;
	min-width :600px;
	box-sizing: border-box
	.filters-container {
		display flex
		flex: 1
		.input-box {
			display flex
			width: 250px
			margin-left: 20px
			span {
				margin-right: 10px
			}
			.filter-input {
				flex: 1
			}
		}
		.btn {
			height: 32px
			margin-top: 14px
			margin-left 20px
		}
	}
}
</style>
